import TrackingService from "@services/tracking/tracking.service";
import { EventTypes } from "@services/tracking/types/eventTypes";

import { CartModel } from "@redux/modules/api/data/cart/@types/cart.model";

import { getCartImpressionTrackingInfo } from "@factory/Tracking/cart.model";

import { TypedAnalyticsEvent } from "../types/analyticsEvent";
import { CartImpressionTrackingInfo } from "../types/trackingInfo/cartImpressionTrackingInfo";
import { getPageInfo, getUserInfo } from "./pageImpressionTracker";

const trackCartImpression = (cart: CartModel, name: string) => {
    const event: TypedAnalyticsEvent<CartImpressionTrackingInfo> = {
        event: EventTypes.CartImpression,
        payload: {
            eventData: getCartImpressionTrackingInfo(cart, name),
            pageInfo: getPageInfo(),
            userInfo: getUserInfo(),
        },
    };

    TrackingService.track(event);
};

export { trackCartImpression };
